$(function () {
    var contactForm = $('form.js-product-contact-form');
    
    contactForm.submit(function (e) {
        e.preventDefault();
                
        var form = $(this);
        var feedbackContainer = $(form).find('.modal-form__feedback');
        var sendButton = $(form).find('.modal-form__send');
        
        sendButton.prop('disabled', true);
        
        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize()
        })
        .done( function( response ) {
            sendButton.prop('disabled', false);
            
            feedbackContainer.html(response.message);
            if (response.RedirectTo) {
                window.location.href = response.redirectTo;
            }
            
            if (response.success) {
                form.replaceWith(feedbackContainer);
            }
            else {
                feedbackContainer.addClass('modal-form__feedback--error');
            }
        })
        .fail( function( response) {
            var responseJson = JSON.parse(response.responseText);
            feedbackContainer.addClass('modal-form__feedback--error');
            feedbackContainer.html(responseJson.message);
            feedbackContainer.append("<div>").append(responseJson.text).append("</div>");
            sendButton.prop('disabled', false);
        });
    });
});


